var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import PropTypes from 'prop-types';

import { MakeFlagIconOptionsPropType } from '../types/propTypes';

var defaultOptions = {
  useCssModules: true
};

export default (function (options) {
  var computedOptions = _extends({}, defaultOptions, options);

  PropTypes.checkPropTypes(MakeFlagIconOptionsPropType(), computedOptions, 'key', 'FlagIconFactory options');
  return computedOptions;
});